import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";

import { mask } from "vue-the-mask";
import ElementPlus from "element-plus";
import * as ElIconModules from '@element-plus/icons-vue';
import ptBr from 'element-plus/es/locale/lang/pt-br';

import i18n from "@/core/plugins/i18n";
import VueCryptojs from 'vue-cryptojs';

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import ReportService from "./core/services/ReportService";
import MockService from "@/core/mock/MockService";
import infraService from "@/core/services/infraService";
import cadService from "@/core/services/cadService";


import fornecService from "@/core/services/fornecService";

import contService from "@/core/services/contService";

import mtzService from "@/core/services/mtzService";
import chmService from "@/core/services/chmService";
import rotService from "@/core/services/rotService";
//import-service-anchor-point

import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

//import components
import customTable from "@/components/custom-table/custom-table.vue"
import customPdfPrint from "@/components/custom-pdf-print/custom-pdf-print.vue"
import customMoney from "@/components/custom-money-component/custom-money-component.vue"
import modalForm from "@/components/modal-form/modal-form.vue"
import filteredRedirect from "@/components/custom-table/filtered-redirect.vue"
import claimAccessControl from "@/components/claim-access-control/claim-access-control.vue"

import { fontawesome } from '@fortawesome/fontawesome-free'


import "@/core/plugins/prismjs";
import "bootstrap";

const app = createApp(App);

app.component("customTable", customTable);
app.component("customMoney", customMoney);
app.component("pdf-print", customPdfPrint);
app.component("modalForm", modalForm);
app.component("filteredRedirect", filteredRedirect);
app.component("claimAccessControl", claimAccessControl);
app.component("fas", fontawesome);

app.directive('mask', mask);

app.use(store);
app.use(router);
app.use(VueCryptojs);
app.use(ElementPlus, {
    locale: ptBr
});

for (const iconName in ElIconModules) {
    if (Reflect.has(ElIconModules, iconName)) {
        const item = ElIconModules[iconName];
        app.component(iconName, item)
    }
}

ApiService.init(app);
ReportService.init(app);
MockService.init(app);
infraService.init(app);
cadService.init(app);


fornecService.init(app);

contService.init(app);

mtzService.init(app);
chmService.init(app);
rotService.init(app);
//init-service-anchor-point

//// modulo de interceptação de requisição
//InterceptorModule.init();

initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
